import { lazy, Suspense } from "react"
import { useProfileStore } from "../state-management/profileStore"
import { useLanguageStore } from "../state-management/languageStore"

const SearchPageContent = lazy(
    () => import("../components/SearchPageComponents/SearchPageContent"),
)
function Saved() {
    const favorites = useProfileStore((state) => state.favorites)
    const t = useLanguageStore((State) => State.translate)
    console.log(
        "favorites",
        favorites,
        useProfileStore((state) => state.favorites),
    )
    return (
        <Suspense fallback={<div></div>}>
            <SearchPageContent
                data={favorites}
                title={t("search.favoritesTitle")}
                notFoundTitle={t("search.favoritesEmpty")}
                doFiltering={false}
            />
        </Suspense>
    )
}

export default Saved
